import i18n from 'core/common/i18n'

export const message = (err, is_group = false) => {
  const unspecific = i18n.t('error.unspecific') ?? err?.message

  if (err?.response?.data?.code === 1) return unspecific

  if (is_group && err?.response?.data?.code === 4) {
    return i18n.t('error.messsageGroup', { msg: err?.response?.data?.message })
  }

  return err?.response?.data?.message ?? unspecific
}
